export const verification = {
    title: 'Подтверждение личности',
    infomation: 'Личная информация.',
    content:
        'Пожалуйста, убедитесь, что все введенные данные соответствуют вашим документам. Вы не сможете изменить информацию после подтверждения.',
    selectInfo: 'Выберите тип личного документа.',
    passport: 'Паспорт',
    identity: 'Удостоверение личности',
    countries: 'Выберите страну',
    numberCmt: 'Номер удостоверения личности',
    numberPassport: 'Номер паспорта',
    identityTitle: 'Фото удостоверения личности.',
    passportTitle: 'Фото паспорта.',
    line1: 'Пожалуйста, убедитесь, что фотография личного документа ясная и содержит все необходимые детали.',
    line2: 'Пожалуйста, используйте  изображение размером не более 10 МБ',
    line3: 'Пожалуйста, используйте изображение в форматах JPG, JPEG, PNG.',
    label1: 'Все детали.',
    label2: 'Не пропущено',
    label3: 'Не размыто',
    label4: 'Без теней',
    contentBefore: 'Загрузите лицевую сторону',
    contentAfter: 'Загрузите обратную сторону',
    imageBefore: 'Лицевая сторона',
    imageAfter: 'Обратная сторона',
    passportLabel: 'Фото паспорта',
    portraitLabel: 'Селфи',
    back: 'Назад',
    nextStep: 'Дальше',
    portraitTitle: 'Сделайте селфи.',
    portraitContent1:
        'Пожалуйста, не надевайте головные уборы, очки или используйте фильтры. ',
    portraitContent2: 'Пожалуйста, используйте изображение размером не более 10 МБ. ',
    portraitContent3: 'Пожалуйста, используйте изображение в форматах JPG, JPEG, PNG.',
    portraitContent4Cccd:
        'Сделайте фотографию вашего лица, держа в руках удостоверение личности и листок с надписью "ste.sbgroup.finance" и текущей датой.',
    portraitContent4Passport:
        'Сделайте фотографию вашего лица, держа в руках паспорт и листок с надписью "ste.sbgroup.finance" и текущей датой.',
    contentPortrait: 'Загрузить фото',
    completeTitle: 'Спасибо за помощь в проверке личности!',
    completeContent: 'Пожалуйста, дождитесь проверки администратором перед совершением покупок',
    gotoHome: 'Перейти на главную',
    requiredImage: 'обязательно',
    required: {
        passportLabel: 'Фото паспорта обязательно',
        portraitLabel: 'Селфи обязательно',
        imageBefore: 'Лицевая сторона обязательна',
        imageAfter: 'Обратная сторона обязательна',
    },
    validateMaxSizeImage: 'Размер файла не должен превышать 10 МБ',
    validateMinSizeImage: 'Размер изображения должен быть не менее 10 кб',
    validateImage: 'Вы можете загружать только изображения в формате JPG, PNG или JPEG',
    placeholderCmt: 'Например: B2412111',
};
